import React from 'react'
import { Route } from 'react-router'

import lang from '@/lang'

const BackupPage = React.lazy(() => import('@/modules/backup/components/backup-page'))

const backupRoutes = (
  <>
    <Route path='backup' Component={BackupPage} handle={{ title: lang.backup.title }} />
  </>
)

export default backupRoutes
